/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postDecisioningStudioAgentsBaseCreativeCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsBaseCreativeProps,
  PostDecisioningStudioAgentsBaseCreativeRequestBody,
  PostDecisioningStudioAgentsBaseCreativeResult,
} from "./types";

export const postDecisioningStudioAgentsBaseCreative = reactQueryMutationAdapter(
  postDecisioningStudioAgentsBaseCreativeCacheKeys,
  (props: PostDecisioningStudioAgentsBaseCreativeProps): Promise<PostDecisioningStudioAgentsBaseCreativeResult> => {
    const body: PostDecisioningStudioAgentsBaseCreativeRequestBody = {
      base_creative_campaign: {
        name: props.name,
        campaign_type: props.campaignType,
        message_variation: props.messageVariation,
      },
    };

    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/base_creatives`,
      "POST",
      body,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
